import { IconProps, NocIconGenerator } from '../common';

export const Couple = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        css={{
            '& path': {
                strokeWidth: '1.2 !important',
            },
        }}
        createIconProps={{
            displayName: 'Couple',
            path: (
                <path
                    d="M11.25 12.29C10.54 10.76 8.68 10.08 7.09999 10.77C5.98 11.26 5.25 12.35 5.25 13.54V16.15H6.6L7.05 20.5H9.74L10.19 16.15H11.09M18.7495 12.2905C18.0394 10.7605 16.1795 10.0805 14.5995 10.7705C13.4795 11.2605 12.7495 12.3505 12.7495 13.5405V16.1504H14.0995L14.5495 20.5005H17.2395L17.6895 16.1504H18.5895M5.74999 6.50001C5.74999 7.88001 6.87 9 8.25 9C9.63 9 10.75 7.88001 10.75 6.50001C10.75 5.12001 9.63 4 8.25 4C6.87 4 5.74999 5.12001 5.74999 6.50001ZM13.2495 6.50049C13.2495 7.88049 14.3695 9.00049 15.7495 9.00049C17.1295 9.00049 18.2494 7.88049 18.2494 6.50049C18.2494 5.12049 17.1295 4.00049 15.7495 4.00049C14.3695 4.00049 13.2495 5.12049 13.2495 6.50049Z"
                    stroke="#212121"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ),
        }}
    />
);
